module.exports = __webpack_public_path__ + "static/media/slashMenu.b9a6b72e.svg";